<template>
  <ElButton :type="type"
            :icon="elIcon"
            :disabled="disabled"
            :loading="loading"
            :round="round"
            :plain="plain"
            :circle="circle"
            :size="size"
            :native-type="nativeType"
            :autofocus="autoFocus"
            :class="classes"
            @click="$emit('click')"
  >
  <slot></slot>
  </ElButton>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
})
export default class extends Vue {
  @Prop({ default: 'primary' }) type!: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'text' | 'outline' | 'tertiary'
  @Prop({ default: '' }) elIcon!: string
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: false }) round!: boolean
  @Prop({ default: false }) plain!: boolean
  @Prop({ default: false }) circle!: boolean
  @Prop({ default: '' }) size!: 'medium' | 'small' | 'mini'
  @Prop({ default: 'button' }) nativeType!: 'button' | 'submit' | 'reset'
  @Prop({ default: false }) autoFocus!: boolean
  @Prop({ default: '' }) classes!: string
}
</script>

<style scoped>
.btn-preview{
  font-size: 10px;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
}
.el-button--text:focus{
  background-color: transparent;
  border-color: transparent;
}
</style>
